import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../css/online-store.scss";

import "react-multi-carousel/lib/styles.css";
import Techstacks from "./../../component/techstacks";

import onlinestore11x from "./../../images/onlinestore/onlinestore-1-1x.png";
import onlinestore12x from "./../../images/onlinestore/onlinestore-1-2x.png";
import onlinestore21x from "./../../images/onlinestore/onlinestore-2-1x.png";
import onlinestore22x from "./../../images/onlinestore/onlinestore-2-2x.png";
import onlinestore31x from "./../../images/onlinestore/onlinestore-3-1x.png";
import onlinestore32x from "./../../images/onlinestore/onlinestore-3-2x.png";
import onlinestore41x from "./../../images/onlinestore/onlinestore-4-1x.png";
import onlinestore42x from "./../../images/onlinestore/onlinestore-4-2x.png";
import onlinestore51x from "./../../images/onlinestore/onlinestore-5-1x.png";
import onlinestore52x from "./../../images/onlinestore/onlinestore-5-2x.png";
import onlinestore61x from "./../../images/onlinestore/onlinestore-6-1x.png";
import onlinestore62x from "./../../images/onlinestore/onlinestore-6-2x.png";

import imgNumber1 from "./../../img/imgNumber1.svg";
import imgNumber2 from "./../../img/imgNumber2.svg";
import imgNumber3 from "./../../img/imgNumber3.svg";
import imgNumber4 from "./../../img/imgNumber4.svg";
import imgNumber5 from "./../../img/imgNumber5.svg";
import imgConclusion from "./../../img/imgConclusion.svg";

function OnlineStore(props) {

	const [onlinestore1WD, setOnlinestore1WD] = useState('');
	const [onlinestore2WD, setOnlinestore2WD] = useState('');
	const [onlinestore3WD, setOnlinestore3WD] = useState('');
	const [onlinestore4WD, setOnlinestore4WD] = useState('');
	const [onlinestore5WD, setOnlinestore5WD] = useState('');
	const [onlinestore6WD, setOnlinestore6WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setOnlinestore1WD(onlinestore11x);
		  setOnlinestore2WD(onlinestore21x);
		  setOnlinestore3WD(onlinestore31x);
		  setOnlinestore4WD(onlinestore41x);
		  setOnlinestore5WD(onlinestore51x);
		  setOnlinestore6WD(onlinestore61x);
	  } else if( props.wd >= 1200 ){
		  setOnlinestore1WD(onlinestore12x);
		  setOnlinestore2WD(onlinestore22x);
		  setOnlinestore3WD(onlinestore32x);
		  setOnlinestore4WD(onlinestore42x);
		  setOnlinestore5WD(onlinestore52x);
		  setOnlinestore6WD(onlinestore62x);
	  }
   },[props.wd]);
  
  return (

      <div>
        <Container>
          <div className="wrapBG">
            <Row className="wrapRowOnlineStore1">
              <Col xl="5" lg="5" md="12" sm="12">
                <h2 className="h2OnlineStore">
                  <span>Онлайн</span> магазин
                </h2>
                <p className="pOnlineStore">
                  Ми спеціалізуємося на розробці та впровадженні рішень, які сприяють продажу страхових договорів безпосередньо через веб-сайт компанії, забезпечуючи безперешкодний та зручний досвід для клієнтів.
                </p>
                <a href="/ua/contact" className="btn buttonOne buttonProduct">Зв'язатися</a>
              </Col>
              <Col xl="7" lg="7" md="12" sm="12">
                <img src={onlinestore1WD} alt="" className="imgOnlineStore1" />
              </Col>
            </Row>
            <Row className="wrapRowTechStacksText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2TechStacksText">Технічні стеки</h2>
              </Col>
            </Row>
            <Row className="wrapRowTechStacksImg">
              <Col xl="12" lg="12" md="12" sm="12">
                <div id="marquee1" className="marquee">
                  <div id="blockSlider" className="marquee__inner">
                    <Techstacks />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ЗАВДАННЯ КЛІЄНТА</h2>
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore4">
              <Col xl="7" lg="7" md="12" sm="12">
                <p className="pCustomerProblems">
                  Наш клієнт прагнув створити повністю онлайн-канал продажів для основних продуктів страхування: туристичне, ОСЦПВ, ОСЦПВ та КАСКО.
                  <br/>
                  <br/>
                  Для створення цього онлайн-каналу клієнт потребував рішення, яке дозволило б:
                </p>
                <ul className="ulCustomerProblems">
                  <li> Налаштовувати правила страхування для обраних продуктів страхування.</li>
                  <li> Налаштовувати тарифи для точних розрахунків цін.</li>
                  <li> Інтегрувати різноманітні варіанти друку.</li>
                  <li> Забезпечити онлайн-підписання страхових договорів.</li>
                  <li> Реалізувати онлайн-процес оплати страхових договорів.</li>
                </ul>
                <p className="pCustomerProblems">
                  Крім того, рішення мало інтегруватися з ІТ-інфраструктурою страхової компанії для використання її послуг з отримання та верифікації даних.
                </p>
              </Col>
              <Col xl="5" lg="5" md="12" sm="12">
                <img
                    src={onlinestore2WD}
                    alt=""
                    className="imgCustomerProblems1"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore5">
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Top"
              >
                <img
                    src={onlinestore3WD}
                    alt=""
                    className="imgCustomerProblems3"
                />
              </Col>
              <Col xl={{ offset: 1, span: 5 }} lg={{ offset: 1, span: 5 }} md="12" sm="12">
                <p className="pOnlineStore1">
                  Для ОСЦПВ рішення повинно було інтегруватися з МТСБУ, оскільки онлайн-продажі таких контрактів проводилися виключно через МТСБУ. Ця інтеграція мала забезпечити відповідність регулятивним вимогам та спростити процес для користувачів.
                  <br/><br/>
                  Зважаючи на те, що страхові продукти можуть бути складними для звичайних осіб, рішення було розроблене з метою спрощення процесу продажу та забезпечення зрозумілості як у процесі покупки, так і в розумінні правил і умов страхових продуктів.
                  <br/><br/>
                  Нарешті, вимагалося, щоб рішення було повністю брендованим для відображення ідентичності компанії та візуально інтегроване в веб-сайт компанії для цілісного та професійного досвіду клієнтів.
                </p>
              </Col>
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Bottom"
              >
                <img
                    src={onlinestore3WD}
                    alt=""
                    className="imgCustomerProblems3"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore6">
              <Col>
                <h2 className="h2OnlineStore1">ПРОЦЕС РОЗРОБКИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessBlock">
              <Col xl="12" lg="12" md="12" sm="12">
                <div className="itemImgNumber itemImgNumber1">
                  <img
                      src={imgNumber1}
                      alt=""
                      className="imgNumber imgNumber1"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Концепція рішення та визначення проблеми:</b>
                    <br/>- Співпраця з клієнтом для визначення загальної концепції рішення та визначення основних проблем, які потрібно вирішити. Цей етап ляже в основу проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber2">
                  <img
                      src={imgNumber2}
                      alt=""
                      className="imgNumber imgNumber2"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Регулярні зустрічі для виведення статусу:</b>
                    <br/>- Проведення щотижневих зустрічей для виведення статусу зі спонсором проекту та ключовими членами робочої групи. Ці зустрічі служать платформою для постійного спілкування та вирівнювання з метою проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber3">
                  <img
                      src={imgNumber3}
                      alt=""
                      className="imgNumber imgNumber3"
                  />
                  <p className="pDevelopmentProcess">
                    <b>План дій та узгодження концепцій:</b>
                    <br/>- Розроблення планів дій та узгодження концепцій рішення та макетів. Цей ітераційний процес допомагає створити спільне бачення та розуміння напрямку рішення.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber4">
                  <img
                      src={imgNumber4}
                      alt=""
                      className="imgNumber imgNumber4"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Демонстрація прогресу розробки:</b>
                    <br/>- Показ проміжних результатів розробки клієнту та зацікавленим сторонам проекту. Цей процес забезпечує прозорість та дозволяє отримати ранній зворотний зв'язок та внести корективи.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber5">
                  <img
                      src={imgNumber5}
                      alt=""
                      className="imgNumber imgNumber5"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Планування масштабованості:</b>
                    <br/>- Обговорення та коригування планів масштабованості для майбутнього рішення. Масштабованість має важливе значення для врахування зростаючого попиту та змін у страховій галузі.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore7">
              <Col>
                <h2 className="h2OnlineStore1">РЕЗУЛЬТАТИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore8">
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pOnlineStore1">
                  Для досягнення наших цілей ми налаштували та впровадили кілька модулів системи управління відносинами з клієнтами Sagacity, зокрема:
                  <br />- Sagacity Web Store
                  <br />- Sagacity Insurance
                  <br />- Sagacity Business Rules
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={onlinestore4WD}
                    alt=""
                    className="imgResultsProduct1"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore9">
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Top"
              >
                <img
                    src={onlinestore5WD}
                    alt=""
                    className="imgResultsProduct2"
                />
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pOnlineStore1">
                  Ми створили необхідні страхові продукти, забезпечили відповідність модуля Sagacity Web Store вимогам корпоративного стилю згідно зі стандартами BrandBook клієнта та успішно впровадили рішення.
                  <br />
                  <br />
                  Фаза розробки тривала 4 місяці, протягом якої команда успішно врахувала всі бізнес-потреби клієнта.
                  <br />
                  <br />
                  Після завершення розробки ми забезпечили інтенсивне навчання співробітників клієнта і подальший запуск системи для використання в реальних умовах.
                </p>
              </Col>
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="colImgCustomerProblems3Bottom"
              >
                <img
                    src={onlinestore5WD}
                    alt=""
                    className="imgResultsProduct2"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineStore10">
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pOnlineStore1">
                  Як результат, рішення забезпечило повернення інвестицій всього за 6 місяців, включно з витратами на розробку та впровадження.
                  <br />
                  <br />
                  Наступні етапи проекту включають подальший розвиток та створення нових онлайн-продуктів на основі цієї платформи, що свідчить про постійну інновацію та розширення.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={onlinestore6WD}
                    alt=""
                    className="imgResultsProduct3"
                />
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ВИСНОВОК</h2>
              </Col>
            </Row>
            <Row className="wrapRowConclusion">
              <Col xl="6" lg="6" md="12" sm="12">
                <div className="wrapConclusionText">
                  <p className="pConclusion">
                    Цей результат є переконливим прикладом того, як навіть під час таких викликів як карантин, запуск нових рішень може ефективно допомагати страховим компаніям залучати нових клієнтів. Особливо варто відзначити, що це рішення має додаткову перевагу у тому, що воно дозволяє людям без попереднього досвіду в страхуванні генерувати додатковий дохід.
                    <br/>Це підкреслює цінність інновацій та адаптивності для трансформації взаємодії з клієнтами та бізнес-операцій.
                  </p>
                  <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
                </div>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={imgConclusion} alt="" className="imgConclusion" />
              </Col>
            </Row>
          </div>
        </Container>
      </div>

  );
}

export default OnlineStore;
